import classNames from "classnames";
import homeStyles from "../HomeLayout.module.scss";
import styles from "./NewAndUpdatedContentSection.module.scss";
import { getRandomPopularTopics } from "../../../utils/getConstants";
import { useDispatch, useSelector } from "react-redux";
import { getDitaContent, selectDitaContent } from "../../Content/ContentSlice";
import { useUpdatesClickAction } from "../../../hooks/updatesHooks/useUpdatesClickAction";
import useDebouncedMutationEffect from "../../../hooks/useDebouncedMutationEffect";
import { useRef } from "react";

const NewAndUpdatedContentSection = () => {
  const popularTopics = getRandomPopularTopics(5);
  const topicList = [];
  const ref = useRef(null);
  const { clickAction } = useUpdatesClickAction(ref);
  useDebouncedMutationEffect(ref, clickAction, [], 100);

  popularTopics.forEach((topic, index) => {
    topicList.push(
      <a
        key={`topic-${index}-${topic.link}`}
        href={topic.link}
        className={classNames("size-16 regular", styles.linkLine)}
      >
        <div className={classNames(styles.topicsLink)}>{topic.title}</div>
      </a>,
    );
  });

  const content = useSelector(selectDitaContent);
  const dispatch = useDispatch();
  const updateContent = getDitaContent(
    "Updates/New_and_updated_content_landing_page.ditamap",
    content,
    dispatch,
  );
  let heading = "";
  let updateText = "";
  if (updateContent) {
    const section = updateContent.getElementsByTagName("chapter")[0];
    const sectionContent = getDitaContent(
      "Updates/" + section?.attributes.href.value,
      content,
      dispatch,
    );
    if (sectionContent) {
      const headingEl =
        sectionContent.getElementsByTagName("title")[0] ||
        sectionContent.getElementsByTagName("ditatitle")[0];
      heading = headingEl?.textContent;
      updateText = sectionContent.getElementsByTagName("conbody")[0]?.innerHTML;
    }
  }
  return (
    <section className={classNames(homeStyles.section, styles.section)}>
      <div className={styles.updateSection} ref={ref}>
        <h2 className={homeStyles.title}>New and updated content</h2>
        <div className={styles.updateBox}>
          <div className={styles.updateHeader}>{heading}</div>
          <div
            className={styles.updateText}
            dangerouslySetInnerHTML={{ __html: updateText }}
          ></div>
          <a className={styles.updateLink} href="/updates">
            <div>View all updates</div>
            <i className="size-12 tg-icons-Carat"></i>
          </a>
        </div>
      </div>
      <div className={styles.randomTopicBox}>
        <div className={classNames("size-16 medium", styles.topicsHeader)}>
          Have you seen these topics?
        </div>
        <div>{topicList}</div>
      </div>
    </section>
  );
};

export default NewAndUpdatedContentSection;